import React from 'react';

interface RoslinBrandingProps {
  showTagline?: boolean;
  variant?: 'large' | 'medium' | 'small';
  className?: string;
}

const RoslinBranding: React.FC<RoslinBrandingProps> = ({ 
  showTagline = true, 
  variant = 'large',
  className = ''
}) => {
  const sizeClasses = {
    large: 'roslin-branding-large',
    medium: 'roslin-branding-medium',
    small: 'roslin-branding-small'
  };

  return (
    <div className={`roslin-branding ${sizeClasses[variant]} ${className}`}>
      <div className="roslin-logo">
        <svg className="roslin-svg" viewBox="0 0 2195.8 555.06" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <style>{`.cls-1{fill:#244376;}.cls-2{fill:#ef4d41;}.cls-3{fill:#c9463c;}`}</style>
          </defs>
          <title>logo_Roslin_RGB</title>
          <path className="cls-1" d="M1077.25,1071.66h-81.8V730h78.64v47.19q31.47-56,95-56a121.58,121.58,0,0,1,40.9,6.92l-6.92,78.65q-22-6.9-39.65-6.91-39.63,0-62.92,26.73t-23.27,78.34Z" transform="translate(-414.2 -593.45)"/>
          <path className="cls-1" d="M1223.86,900.51q0-75.51,51-127.1,52.23-52.23,131.51-52.23,79.89,0,130.88,52.23,51.57,51.6,51.59,127.1,0,76.77-51.59,128.36-51,51.6-130.88,51.6t-131.51-51.6Q1223.85,977.29,1223.86,900.51Zm282.51,0q0-43.41-28.94-73-29.58-30.19-71.1-30.2t-71.1,30.2q-28.95,29.58-29,73,0,44,29,73.62,29.57,30.2,71.1,30.2t71.1-30.2Q1506.37,944.57,1506.37,900.51Z" transform="translate(-414.2 -593.45)"/>
          <path className="cls-1" d="M1761.21,1080.47q-88.73,0-137.8-68L1670,962.17a121.78,121.78,0,0,0,41.85,35.55q24.84,12.91,50,12.9,22,0,36.18-10.38t14.16-25.48q0-20.14-25.8-32.72-8.19-5-41.53-17-29.58-11.32-43.42-18.25-57.26-28.31-57.25-86.83,0-44.67,34-73t90-28.32q72.36,0,117,50.34l-42.78,52.23Q1809,786,1765.61,786q-18.87,0-30.2,9.12t-11.33,23q0,22.65,29.58,33.35,74.88,29.58,82.43,34Q1894,916.88,1894,972.24q0,46.57-36.49,77.39T1761.21,1080.47Z" transform="translate(-414.2 -593.45)"/>
          <path className="cls-1" d="M2038.69,593.45v478.21h-81.8V593.45Z" transform="translate(-414.2 -593.45)"/>
          <rect className="cls-1" x="1709.42" y="136.54" width="82.43" height="341.66"/>
          <path className="cls-1" d="M2369.63,1071.66h-81.79V730h80.54v47.82q13.83-26.43,42.16-41.53t65.44-15.1q56,0,95,37.13t39,105.07v208.28h-82.43V886q0-42.15-20.13-66.07t-54.75-23.91q-36.49,0-59.77,25.48t-23.29,65.75Z" transform="translate(-414.2 -593.45)"/>
          <rect className="cls-2" x="2123.65" y="593.45" width="82.43" height="82.43" transform="translate(2385.33 -2123.65) rotate(90)"/>
          <polygon className="cls-3" points="402.3 273.55 237.22 273.55 154.8 415.05 322.3 415.05 402.3 273.55"/>
          <path className="cls-2" d="M889.28,730.93a6.82,6.82,0,0,0-5.91-3.41H421a6.83,6.83,0,0,0-5.91,10.25l71.25,125.76a6.83,6.83,0,0,0,5.91,3.42l324.22,0,72.78-129.23A6.8,6.8,0,0,0,889.28,730.93Z" transform="translate(-414.2 -593.45)"/>
          <path className="cls-2" d="M569,1008.5l77.44,136.62a6.79,6.79,0,0,0,11.75,0l78.31-136.73Z" transform="translate(-414.2 -593.45)"/>
        </svg>
      </div>
      {showTagline && (
          <p className="hero-tagline">It's a better way to move forward</p>
      )}
    </div>
  );
};

export default RoslinBranding;